import type { ColumnConfig } from "./types";

export const generateGridColStyle = (columns: ColumnConfig[]) => {
	return columns
		.map((column: ColumnConfig) => {
			// if width is not provide, set col to equal width
			if (!column?.width) return "1fr";
			// if number provide, set column width to grid fraction
			else if (typeof column.width === "number") {
				return `${column.width}fr`;
				// if string provide, set column width to pixel value
			} else if (typeof column.width === "string") {
				return `${column.width}px`;
			} else {
				return "1fr";
			}
		})
		.join(" ");
};

export const filterHiddenCols = (columns: ColumnConfig[], isMobile: boolean) =>
	columns.filter(column => {
		if (isMobile) {
			return !column.mobileConfig?.hidden;
		} else {
			return !column.hidden;
		}
	});

export const sortColsByOrder = (columnA: ColumnConfig, columnB: ColumnConfig) => {
	const orderA = columnA.mobileConfig.order || 0;
	const orderB = columnB.mobileConfig.order || 0;
	return orderA - orderB;
};
